import { render, staticRenderFns } from "./SelectionDossiersDeClientsModal.vue?vue&type=template&id=20464720&"
import script from "./SelectionDossiersDeClientsModal.vue?vue&type=script&lang=js&"
export * from "./SelectionDossiersDeClientsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports